<template>
  <div class="reconcileBillQuery">
    <el-form
      :inline="true"
      label-width="120"
      :model="searchForm"
      :show-message="false"
      ref="searchForm"
      class="search-form"
    >
      <el-row>
        <el-col :span="6">
          <el-form-item prop="businessLine" label="业务线" required>
            <el-select filterable required v-model="searchForm.businessLine" @change="selectChange">
              <el-option
                v-for="item in businessLineList"
                :label="item.label"
                :value="item.value"
                :key="item.value"
              />
            </el-select>
            <!-- <filter-business-line :value.sync="searchForm.businessLine" :ops="false" required /> -->
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item prop="supplierId" label="合作商名称" required>
            <filter-businessline-partner
              :value.sync="searchForm.supplierId"
              :code.sync="searchForm.supplierCode"
              :businessLine="searchForm.businessLine"
              required
            />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item prop="regionId" label="regionName">
            <filter-businessline-region
              :value.sync="searchForm.regionId"
              style="width: 193px"
              :businessLine="searchForm.businessLine"
            />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item prop="periodMonth" label="结算账期">
            <el-date-picker
              style="width:193px"
              v-model="searchForm.periodMonth"
              type="month"
              :clearable="false"
              value-format="yyyy-MM"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="6">
          <el-form-item prop="orderId" label="对账单号">
            <el-input clearable v-model="searchForm.orderId" placeholder="清输入账单号" />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item prop="billType" label="对账单类别">
            <el-select filterable clearable v-model="searchForm.billType">
              <el-option
                v-for="item in billTypeList"
                :label="item.label"
                :value="item.value"
                :key="item.value"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item prop="billStatus" label="对账单状态">
            <el-select filterable clearable v-model="searchForm.billStatus">
              <el-option
                v-for="item in billStateTypeList"
                :label="item.label"
                :value="item.value"
                :key="item.value"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6" class="align-r">
          <el-button type="primary" @click="getTableData('query')" :loading="isLoading"
            >查询</el-button
          >
          <el-button @click="reset">重置</el-button>
        </el-col>
      </el-row>
    </el-form>
    <el-table stripe v-loading="isLoading" :data="tableData" :span-method="arraySpanMethod">
      <el-table-column prop="orderId" label="对账单号" width="200">
        <template slot-scope="{ row }">
          <el-row type="flex" justify="start">
            <div style="width: 200px;">{{ row.orderId }}</div>
            <div>{{ row.agentName }}</div>
          </el-row>
          <!-- 合伙人分成 + 待合作商确认 -->
          <div
            v-if="row.agentTypeStr === '合伙人' && row.billProcessStatus === 30"
            class="confirm-tip"
          >
            请您3个工作日内确认账单，若逾期系统将自动确认账单
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="agentName" label="合作商名称" width="300" />
      <el-table-column prop="regionName" label="RegionName" width="180" />
      <el-table-column prop="periodMonth" label="结算账期" width="100" />
      <el-table-column v-if="isEbike" prop="actuallyMoney" label="实收总金额" width="100" />
      <el-table-column v-if="isEbike" prop="noTaxMoney" label="不含税金额" />
      <el-table-column prop="billTotalMoney" label="账单总金额" width="100" />
      <el-table-column v-if="isEbike" prop="bondMoney" label="保证金金额" />
      <el-table-column v-if="isEbike" prop="deductMoney" label="抵扣金额合计" width="120" />
      <el-table-column prop="billStatusStr" label="对账单状态" width="120" />
      <el-table-column prop="billTypeStr" label="对账单类别" />
      <el-table-column prop="createTime" label="生成时间" width="150" />
      <el-table-column label="操作" fixed="right" width="80">
        <template slot-scope="scope">
          <router-link
            target="_blank"
            :to="{
              name: '/bill/reconcileBillDetail',
              query: {
                orderId: scope.row.orderId,
                businessLine: searchForm.businessLine,
                billType: scope.row.billType,
              },
            }"
            >查看详情
          </router-link>
        </template>
      </el-table-column>
    </el-table>

    <div class="paging-wrapper" v-if="totalPages > 1">
      <el-pagination
        @current-change="handlePageNoChange"
        :current-page.sync="pageNo"
        :page-size="pageSize"
        layout="prev, pager, next, slot, jumper"
        :total="totalAmount"
      >
        <span class="page-indicator"
          ><em>{{ pageNo }}</em
          >/{{ totalPages }}</span
        >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import { stateTypeList } from './constant'
import pagination from '@/mixins/pagination'
import { calAccountPeriod } from '@/utils'
import { mapState } from 'vuex'

export default {
  name: 'reconcileBillQuery',
  components: {},
  props: [],
  mixins: [pagination],
  data() {
    return {
      initFlag: true,
      isLoading: false,
      tableData: [],
      selTableRows: [],
      searchForm: {
        periodMonth: calAccountPeriod(new Date()),
        businessLine: 1203,
      },
      businessLineList: [
        {
          label: '电单车',
          value: 1203,
        },
        {
          label: '单车',
          value: 1204,
        },
      ],
      billTypeList: stateTypeList.eBikeTypeList,
      billStateTypeList: stateTypeList.eBikeStateTypeList,
    }
  },
  computed: {
    ...mapState('reconcileBill', [
      'agentBillStatus',
      // 'partners',
      // 'businessLine',
      // 'authRegions',
      'agentType',
    ]),
    isEbike() {
      return this.searchForm.businessLine === 1203
    },
  },
  created() {
    this.init()
  },
  watch: {
    searchForm: {
      handler(val) {
        if (val.businessLine && val.supplierId && this.initFlag) {
          this.getTableData('query')
          this.initFlag = false
        }
      },
      deep: true,
    },
  },
  mounted() {},
  methods: {
    async init() {
      this.getDictMap()
      this.initPagination('getTableData', false)
      this.$debugVue('v_reconcileBillQuery', this)
    },
    async getDictMap() {
      const params = {
        businessLine: this.searchForm.businessLine,
      }
      const res = await this.fetch.get('reconcileBill_dictMap', { params })
      if (res) {
        const {
          agentBillProcessStatus = {},
          agentType = {},
          agentBillStatus = {},
          // businessLine = {},
        } = res.data
        this.$store.commit(
          'reconcileBill/mu_agentBillProcessStatus',
          agentBillProcessStatus.list || []
        )
        this.$store.commit('reconcileBill/mu_agentType', agentType.list || [])
        this.$store.commit('reconcileBill/mu_agentBillStatus', agentBillStatus.list || [])
        // this.$store.commit('reconcileBill/mu_businessLine', businessLine.list || [])
      }
      // const res2 = await this.fetch.get('commonGetAuthRegions')
      // if (res2) {
      //   this.$store.commit('reconcileBill/mu_authRegions', res2.data.list || [])
      // }

      // const res3 = await this.fetch.get('commonGetPartners')
      // if (res3) {
      //   this.$store.commit('reconcileBill/mu_partners', res3.data.partnerModelList || [])
      // }
    },
    reset() {
      this.$refs.searchForm.resetFields()
    },
    async getTableData(type) {
      type === 'query' && (this.pageNo = 1)
      const params = {
        pageNumber: this.pageNo,
        pageSize: this.pageSize,
        ...this.searchForm,
        supplierId: this.searchForm.supplierCode,
      }
      delete params.supplierCode
      this.isLoading = true
      try {
        const res = await this.fetch.get('reconcileBill_billSearch', { params })
        if (res) {
          const { list, total } = res.data
          this.tableData = list
          this.totalAmount = total
        }
        this.isLoading = false
      } catch (err) {
        console.log(err)
        this.isLoading = false
      }
    },
    // 根据业务线变化账单类别/状态
    selectChange(item) {
      if (item === 1204) {
        this.billTypeList = stateTypeList.bikeTypeList
        this.billStateTypeList = stateTypeList.bikeStateTypeList
      } else {
        this.billTypeList = stateTypeList.eBikeTypeList
        this.billStateTypeList = stateTypeList.eBikeStateTypeList
      }
    },

    arraySpanMethod({ columnIndex }) {
      if (columnIndex === 0) {
        return [1, 2]
      } else if (columnIndex === 1) {
        return [0, 0]
      }
    },
  },
}
</script>
